export default {
  en: {
    global: {
      required: 'The {field} field is required.',
      email: 'E-mail is not valid',
      between: 'Number {field} has to be between {min} and {max}'
    },
    custom: {},
    attributes: {
      'invoiceLiability.DebtorCompanyNumber': 'Budget Id Number',
      'invoiceLiability.InvoiceNumber': 'Invoice Number',
      'invoiceLiability.Amount': 'Amount',
      'invoiceLiability.IssueDate': 'Issue Date',
      'invoiceSettlement.InvoiceId': 'Invoice ID',
      'invoiceSettlement.ExternalId': 'Payment ID',
      'invoiceSettlement.SettlementDate': 'Settlement date',
      'invoiceSettlement.Bank': 'Bank',
      'register.companyNumber': 'Company Number',
      'register.parentInstitutionTaxIdNumber': 'Parent Company Tax Id Number',
      'register.parentInstitutionCompanyNumber': 'Parent Company Number',
      'register.taxIdNumber': 'Tax Id Number',
      'register.name': 'Company Name',
      'register.companyName': 'Company / Legal Entity Name',
      'register.legalEntityName': 'Legal Entity Name',
      'register.address': 'Address',
      'register.treasuryBranch': 'Treasury Branch',
      'register.email': 'Company e-mail',
      'register.phoneNumber': 'Company phone',
      'register.adminName': 'Name and last name',
      'register.adminPersonalIdentityNumber': 'Personal identity number',
      'register.adminIdentityNumber': 'Identity number',
      'register.adminEmail': 'Admin Email',
      'register.adminPhoneNumber': 'Admin Phone',
      'user.login': 'User login',
      'user.name': 'User name',
      'user.email': 'User email',
      'groupSettlement.groupSettlementNumber': 'Group settlement number'
    }
  },
  sr: {
    global: {
      required: '{field} је обавезно поље.',
      email: 'Имејл адреса није валидна.',
      between: '{field} мора бити између {min} и {max}.'
    },
    custom: {
      form: {
        name: {
          required: 'Upisi ime',
          minLength: 'Ime mora imati najmanje 5 karaktera'
        }
      }
    },
    attributes: {
      'form.surname': 'Prezime',
      'invoiceLiability.DebtorCompanyNumber': 'ЈББК дужника',
      'invoiceLiability.InvoiceNumber': 'Број фактуре',
      'invoiceLiability.Amount': 'Износ',
      'invoiceLiability.IssueDate': 'Датум издавања',
      'invoiceSettlement.InvoiceId': 'Идентификатор фактуре',
      'invoiceSettlement.ExternalId': 'Идентификатор плаћања',
      'invoiceSettlement.SettledAmount': 'Износ измирења',
      'invoiceSettlement.SettlementDate': 'Датум измирења',
      'invoiceSettlement.Bank': 'Банка',
      'register.companyNumber': 'Матични број',
      'register.parentInstitutionTaxIdNumber': 'ПИБ надређене институције',
      'register.parentInstitutionCompanyNumber': 'Матични број надређене институције',
      'register.taxIdNumber': 'ПИБ',
      'register.name': 'Име компаније / јавног предузећа',
      'register.companyName': 'Име компаније',
      'register.legalEntityName': 'Име јавног предузећа',
      'register.address': 'Адреса седишта',
      'register.treasuryBranch': 'Испостава трезора',
      'register.email': 'Име компаније',
      'register.phoneNumber': 'Телефон компаније',
      'register.adminName': 'Име и презиме',
      'register.adminIdentityNumber': 'Број личне карте',
      'register.adminEmail': 'Админ и-мејл',
      'register.adminPhoneNumber': 'Админ телефон',
      'user.login': 'Кориснички налог',
      'user.name': 'Име и презиме',
      'user.email': 'Имејл корисника',
      'groupSettlement.groupSettlementNumber': 'Број спецификације групног плаћања'
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/validation.js